module.exports = __webpack_public_path__ + "img/customer-care.136a4f89.svg";